import { render } from "./ControlSettings.vue?vue&type=template&id=1d8bb1a2&ts=true"
import script from "./ControlSettings.vue?vue&type=script&lang=ts"
export * from "./ControlSettings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__